module.exports = __webpack_public_path__ + "static/media/note.b22c692e.svg";